<template>
  <div class="main-content">
    <a-t-loader v-if="isLoadingAllPartners" />

    <template v-else>
      <div class="page-content">
        <div class="container">
          <section class="partners-block">
            <div class="page-title">
              <h2>Partners</h2>
            </div>

            <div class="partners-block_search">
              <div class="search-inner">
                <div class="block-search">
                  <input
                    class="input-search"
                    v-model="inputSearchCompanyName"
                    type="text"
                    placeholder="Company Name" />
                </div>
                <div class="block-search-btn">
                  <a
                    @click="filterCompany"
                    href="javascript:void(0)"
                    class="btn btn--green btn_search-vs">
                    <svg width="1em" height="1em" class="icon icon-search">
                      <use
                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-search"></use>
                    </svg>
                  </a>
                </div>
                <a
                  @click="clearFilterPartners"
                  class="story-templates__table__top-clear"
                  :style="{cursor: 'pointer'}">
                  Clear
                </a>
              </div>

              <div class="page-title__side">
                <div
                  class="btn btn--green"
                  @click="openModalEditPartner('new', templateNewPartner)">
                  <span>Add Partner</span>
                </div>
              </div>
            </div>

            <div class="page-title">
              <h2>All partners</h2>
            </div>

            <div class="partners-block_list">
              <div class="partners-block_table-wrapper">
                <div class="partners-block_table">
                  <div
                    class="partners-block_table-row partners-block_table-row-header">
                    <div class="col partner-name">Company Name</div>
                    <div class="col partner-tin">TIN</div>
                    <div class="col partner-vrn">VRN</div>
                    <div class="col partner-mobile">Mobile</div>
                    <div class="col partner-address">Address</div>
                    <div class="col partner-options"></div>
                  </div>
                  <div
                    v-for="(partner, index) in resultSearchPartners.slice((page - 1) * 6, ((page - 1) * 6) + 6)"
                    :key="partner.id"
                    class="partners-block_table-row partners-block_table-row-body">
                    <div class="col partner-name">
                      <span>{{ index + 1 }}.</span> {{ partner.companyName }}
                    </div>
                    <div class="col partner-tin">{{ partner.tin }}</div>
                    <div class="col partner-vrn">{{ partner.vrn }}</div>
                    <div class="col partner-mobile">{{ partner.phone }}</div>
                    <div class="col partner-address">{{ partner.address }}</div>
                    <div class="col partner-options">
                      <button
                        type="button"
                        class="btn form-control-action"
                        @click="openModalEditPartner('edit', partner)">
                        <span class="form-control-action__icon icon--green">
                          <svg width="1em" height="1em" class="icon icon-edit">
                            <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-edit"></use>
                          </svg>
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <pagination
              :page="page"
              :pageCount="pageCount"
              @pageController="pageController" />

          </section>
        </div>
      </div>
    </template>

    <a-t-modal-partners
      v-if="isModalPartners"
      @closeModalPartnerParameters="closeModalPartner"
      @changePartnerParameters="changeModalPartner"
      :currentPartner="currentPartner" />
  </div>
</template>

<script>
import Vuex from 'vuex'
import ATLoader from '@/components/Loaders/Loader'
import ATModalPartners from '@/components/Modals/Partners/ModalParners'
import {
  actionTypes as actionTypesPartners,
  getterTypes as getterTypesPartners,
} from '@/store/modules/partners'
import Pagination from '@/components/Pagination'
export default {
  name: 'ATPartners',
  data() {
    return {
      isModalPartners: false,
      inputSearchCompanyName: '',
      resultSearchPartners: [],
      currentPartner: {},
      page: 1,
      pageCount: 0,
      templateNewPartner: {
        companyName: '',
        shortName: '',
        tin: '',
        vrn: '',
        countryCode: '',
        phone: '',
        address: '',
        logoImageId: '',
      },
    }
  },
  components: {Pagination, ATModalPartners, ATLoader},
  computed: {
    ...Vuex.mapGetters({
      isLoadingAllPartners: getterTypesPartners.isLoadingAllPartners,
      allPartners: getterTypesPartners.allPartners,
    }),
  },
  watch: {
    allPartners() {
      this.pageCountHandler()
    },
  },
  methods: {
    ...Vuex.mapActions({
      findPartners: actionTypesPartners.findPartners,
      createdPartner: actionTypesPartners.createdPartner,
      updatedPartner: actionTypesPartners.updatedPartner,
    }),
    pageController(page) {
      this.page = page
    },
    pageCountHandler() {
      this.pageCount = Math.ceil(this.allPartners.length / 6)
    },
    findAllPartners() {
      this.findPartners().then(
        () => (this.resultSearchPartners = this.allPartners)
      )
    },
    openModalEditPartner(flag, partner) {
      if (flag === 'new') {
        this.isModalPartners = true
        this.currentPartner = Object.assign(
          {
            type: flag,
          },
          partner
        )
      }

      if (flag === 'edit') {
        this.isModalPartners = true
        this.currentPartner = Object.assign(
          {
            type: flag,
          },
          partner
        )
      }
    },
    filterCompany() {
      this.resultSearchPartners = this.allPartners.filter((item) => {
        return this.inputSearchCompanyName
          ? item.companyName
              .toLowerCase()
              .includes(this.inputSearchCompanyName.toLowerCase())
          : true
      })
      this.pageCount = Math.ceil(this.resultSearchPartners.length / 6)
    },
    clearFilterPartners() {
      this.inputSearchCompanyName = ''
      this.findAllPartners()
    },
    changeModalPartner(value) {
      if (value.type === 'new') this.createdPartner(value).then(() => this.findAllPartners())
      if (value.type === 'edit') this.updatedPartner(value).then(() => this.findAllPartners())
    },
    closeModalPartner(val) {
      this.isModalPartners = val
    },
  },
  mounted() {
    this.findAllPartners()
  },
}
</script>
